/** Версия политики ПДн — синхронизировать с юристом при обновлении документов. */
export const POLICY_VERSION = '2026-05-28';

/** Архив PDF на Яндекс.Диске (для скачивания; основной текст — на сайте). */
export const LEGACY_POLICY_PDF_URL =
  'https://disk.360.yandex.ru/i/JguulL4ZgxS6qA';

export const LEGAL_LINKS = {
  privacy: '/privacy',
  cookies: '/cookies',
  privacyPdf: LEGACY_POLICY_PDF_URL,
};

/** @deprecated Используйте LEGAL_LINKS.privacy */
export const PRIVACY_POLICY_PATH = LEGAL_LINKS.privacy;
